import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from './store'
import VueCookies from 'vue-cookies';
import utils from './config/utils.js';
import services from './config/services.js';

import HomeIndex from './Index.vue'
import User from './pages/user/User.vue'
import StudyRecord from './pages/user/model/StudyRecord.vue'
import MyClass from './pages/user/model/MyClass.vue'
import myPractice from './pages/user/model/myPractice.vue'
import myNote from './pages/user/model/myNote.vue'
import AgainPractice from './pages/user/model/AgainPractice.vue'
import NowPractice from './pages/user/model/NowPractice.vue'
import myAssess from './pages/user/model/myAssess.vue'
import assessAnswer from './pages/user/model/assessAnswer.vue'
import againAssess from './pages/user/model/againAssess.vue'
import Class from './pages/class/Class.vue'
import Class404 from './pages/class/Class404.vue'
import ClassDetail from './pages/class/ClassDetail.vue'
import ClassVideo from './pages/class/ClassVideo.vue'
import Page404 from './components/Page404.vue'
import myCertificate from './pages/user/model/myCertificate.vue'
import Study from './pages/study/index.vue'
import myStudy from "./pages/user/model/myStudy.vue"
import HzvtcIndex from "@/pages/hzvtc/index.vue"
import HzvtcListCulture from "@/pages/hzvtc/list/culture.vue"
import HzvtcListProfession from "@/pages/hzvtc/list/profession.vue"
import HzvtcListValue from "@/pages/hzvtc/list/value.vue"
import HzvtcListFeelings from "@/pages/hzvtc/list/feelings.vue"
import HzvtcListFeature from "@/pages/hzvtc/list/feature.vue"
import HzvtcListVita from "@/pages/hzvtc/list/vita.vue"
import HzvtcDetail from "@/pages/hzvtc/detail.vue"
import HzvtcSearch from "@/pages/hzvtc/search.vue"


Vue.use(VueRouter)
var staticRoutes = [
  {
    path: '/:schoolcode(\\d+)/user',
    name: '个人中心',
    component: User,
    children: [
      {
        path: 'studyRecord',
        name: '学习记录',
        component: StudyRecord
      },
      {
        path: 'myClass',
        name: '我的课程',
        component: MyClass
      },
      {
        path: 'center',
        redirect: '/:schoolcode(\\d+)/user/myClass'
      },
      {
        path: 'userMessage',
        redirect: '/:schoolcode(\\d+)/user/myClass'
      },
      {
        path: 'userMessage/modifyPhone',
        redirect: '/:schoolcode(\\d+)/user/myClass'
      },
      {
        path: 'userMessage/bindPhone',
        redirect: '/:schoolcode(\\d+)/user/myClass'
      },
      {
        path: 'userMessage/modifyEmail',
        redirect: '/:schoolcode(\\d+)/user/myClass'
      },
      {
        path: 'updatePassword',
        redirect: '/:schoolcode(\\d+)/user/myClass'
      },
      {
        path: 'myPractice',
        name: '我的练习',
        component: myPractice,
      },
      {
        path: 'myAssess',
        name: '我的测评',
        component: myAssess,
      },
      {
        path: 'myNote',
        name: '我的笔记',
        component: myNote,
      },
      {
        path: 'myCertificate',
        name: '我的证书',
        component: myCertificate,
      },
      {
        path: 'myStudy',
        name: '我的数据',
        component: myStudy,
      },


      // myStudy
    ]
  },
  {
    path: '/:schoolcode(\\d+)/class/:classId/',
    component: HomeIndex,
    children: [
      // {
      //   path: '/:schoolcode(\\d+)/class',
      //   name: '课程资源',
      //   component: Class
      // },
      {
        path: '/:schoolcode(\\d+)/class/:classId/',
        name: '课程查看',
        component: ClassDetail
      },
    ]
  },
  {
    path: '/:schoolcode(\\d+)/video/:classId/:videoId',
    name: '课程播放',
    component: ClassVideo
  },
  {
    path: '/:schoolcode(\\d+)/class/notfound',
    name: 'Class404',
    component: Class404
  },
  {
    path: '/:schoolcode(\\d+)/Error',
    name: 'Error',
    component: Error,
  },

  {
    path: '/:schoolcode(\\d+)/user/myPractice/AgainPractice',
    name: '我的练习-再次答题',
    component: AgainPractice,
  },
  {
    path: '/:schoolcode(\\d+)/user/myPractice/NowPractice',
    name: '我的练习-立即答题',
    component: NowPractice,
  },
  {
    path: '/:schoolcode(\\d+)/user/myAssess/assessAnswer',
    name: '我的测评-测评答题',
    component: assessAnswer,
  },
  {
    path: '/:schoolcode(\\d+)/user/myAssess/againAssess',
    name: '我的测评-提交测评',
    component: againAssess,
  },
  { path: "/:schoolcode(\\d+)?/yxlx", component: Study },
  {
    path: '*',
    name: '页面404',
    component: Page404,
  },
  {
    path: "/:school(\\d+)/hzvtc", name: "党建思政教育资源平台", component: HzvtcIndex,
  },
  { path: "/:school(\\d+)/hzvtc/culture", name: "党性修养-党建思政教育资源平台", component: HzvtcListCulture },
  { path: "/:school(\\d+)/hzvtc/profession", name: "职业素养-党建思政教育资源平台", component: HzvtcListProfession },
  { path: "/:school(\\d+)/hzvtc/value", name: "价值引领-党建思政教育资源平台", component: HzvtcListValue },
  { path: "/:school(\\d+)/hzvtc/feelings", name: "家国情怀-党建思政教育资源平台", component: HzvtcListFeelings },
  { path: "/:school(\\d+)/hzvtc/feature", name: "特色文化-党建思政教育资源平台", component: HzvtcListFeature },
  { path: "/:school(\\d+)/hzvtc/vita", name: "生命教育-党建思政教育资源平台", component: HzvtcListVita },
  { path: "/:school(\\d+)/hzvtc/detail", name: "党建思政教育资源平台", component: HzvtcDetail },
  { path: "/:school(\\d+)/hzvtc/search", name: "党建思政教育资源平台", component: HzvtcSearch },
];

const newRoutes = [...staticRoutes];
let router = new VueRouter({
  mode: 'history',
  base: '/center/',
  routes: newRoutes,
})

router.beforeEach((to, from, next) => {
  if (to.path == '/') {
    window.open(`/center/${services.HZ_CODE}/hzvtc`, "_self")
  }
  utils.setTitle(to.name);
  if (!(utils.whiteList.includes(to.path))) {
    let appsToken = VueCookies.get("api_token");
    if (appsToken) {
      next()
    } else {
      let code = utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode")
      if (code) {
        if (code == services.StudyCode) {
          // window.open(`${services.LOGIN_SERVER}/${code}/login?from=${services.XUEXI_HOST}/center/${code}/yxlx`, "_self")
          window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${code}&from=${services.XUEXI_HOST}/center/yxlx`, "_self")
        } else {
          // window.open(`${services.LOGIN_SERVER}/${code}/login?from=${window.location.href}`, "_self")
          window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${code}&from=${window.location.href}`, "_self")
        }
      }
    }
  } else {
    next()
  }
})
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  next();
});
export default router